import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "relative flex h-dvh w-full items-center justify-center px-8 sm:px-0 lg:max-w-none lg:px-0" }
const _hoisted_2 = { class: "w-full lg:max-w-[560px] lg:p-8" }
const _hoisted_3 = { class: "mx-auto flex w-full flex-col space-y-6 sm:w-[350px]" }
const _hoisted_4 = { class: "flex flex-col space-y-2" }
const _hoisted_5 = {
  key: 0,
  class: "text-lg font-medium tracking-tight"
}
const _hoisted_6 = {
  key: 1,
  class: "text-muted-foreground text-xs"
}

import AppLogoIcon from '@/components/AppLogoIcon.vue';
    import KeepersLogo from '@/components/icons/KeepersLogo.vue';
    import { Link, usePage } from '@inertiajs/vue3';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AuthSplitLayout',
  props: {
    title: {},
    description: {}
  },
  setup(__props: any) {

    const page = usePage();
    const name = page.props.name;
    const quote = page.props.quote;

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(KeepersLogo, { type: "dark" }),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.title)
            ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.title), 1))
            : _createCommentVNode("", true),
          (_ctx.description)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.description), 1))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bg-muted relative hidden h-full flex-1 bg-[url('/img/login-bg.jpg')] bg-cover bg-right lg:flex" }, null, -1))
  ]))
}
}

})